/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { getBillingStatusDataSchema } from '../getBillingStatus/get-billing-status-response';

export const getBillingStatusV2DataSchema = getBillingStatusDataSchema.extend({
  planName: z.enum(['free', 'pro', 'gift', 'vip']),
});

export type IGetBillingStatusV2Data = z.infer<typeof getBillingStatusV2DataSchema>;

export const getBillingStatusV2ResponseSchema = createApiResponseSchema(
  getBillingStatusV2DataSchema,
) as z.ZodSchema<IAPI<IGetBillingStatusV2Data>>;

export type IGetBillingStatusV2Response = IAPI<IGetBillingStatusV2Data>;
